import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateCountryList = {
  countryList: { data: null, loading: false, error: null },
};

export const countryList = createAsyncThunk('user/countryList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/country/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCountryList = {
  [countryList.pending]: (state) => {
    state.countryList.loading = true;
  },
  [countryList.fulfilled]: (state, action) => {
    state.countryList.loading = false;
    state.countryList.data = action.payload;
    state.countryList.error = null;
  },
  [countryList.rejected]: (state, action) => {
    state.countryList.data = null;
    state.countryList.loading = false;
    state.countryList.error = action.payload;
  },
};
